<template>
  <div id="app">
    <header style="height: 80px;" >
      <HomeHeader/>
    </header>
      <router-view  style="flex: 1;overflow-y: auto;"/>
  </div>
</template>

<script>
  import  HomeHeader from '@/components/home-header/home-header.vue'

export default {
  name: 'App',
  components:{
    HomeHeader,
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
</style>



// WEBPACK FOOTER //
// src/App.vue